var jwt = require('jwt-simple')
export default {
  FnJwtDecode
  // FnJwtEncode
}

// function FnJwtEncode (data) {
//   try {
//     const Str = require('@supercharge/strings')
//     var randomStr = Str.random(32)
//     var encoded = jwt.encode(data, 'bill', false, 'HS256')
//     var encodedPart = encoded.split('.')
//     encodedPart[1] = encodedPart[1] + randomStr
//     var encodedResult = encodedPart[2] + '.' + encodedPart[0] + '.' + encodedPart[1]
//     return encodedResult
//   } catch (err) {
//     return data
//   }
// }

function FnJwtDecode (data) {
  try {
    var decodes = data.split('.')
    var newDecodes = decodes[2].slice(-32)
    decodes[2] = decodes[2].replace(newDecodes, '')
    decodes = decodes[1] + '.' + decodes[2] + '.' + decodes[0]
    var decoded = jwt.decode(decodes, 'bill', false, 'HS256')
    return decoded
  } catch (err) {
    return data
  }
}
